export const normalizeAccentText = (text: string) =>
  text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
